module.exports = {"percentiles":"Percentiles","byteincomingpercentilesnum":"th percentile (incoming traffic)","traffic":"traffic","maximum":"Maximum Value","minimum":"Minimum Value","byteoutgoingpercentilesnum":"th percentile (outgoing traffic)","byteincominglinechart":"Incoming Traffic Trending","byteoutgoinglinechart":"Outgoing Traffic Trending","search":"Search","exportPdf":"Export PDF","moreInfo":"More Info","ipRange":"IP Address Range","timeRange":"Time Range"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en-US/netflowAnalyze.json
// module id = /j0u
// module chunks = 3